import {makeUpdateBatchProcedure} from 'main/factories/usecases/private/refund/request/update-batch-procedure';
import {UpdateBatchProcedureParams} from 'domain/usecases/private/refund/request/update-batch-procedure';

export async function updateBatchProcedure(params: UpdateBatchProcedureParams) {
	const updateBatchRefundProcedure = makeUpdateBatchProcedure();
	return updateBatchRefundProcedure.update(params);
}
